// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tableContainer___f8SGk{padding:16px;background:var(--white);flex-grow:1}\n", "",{"version":3,"sources":["webpack://./src/routes/ManageTenants/components/TenantGroupsTable/TenantGroupsTable.css"],"names":[],"mappings":"AAAA,wBAAA,YAAA,CAEI,uBAAA,CACA,WAAA","sourcesContent":[".tableContainer {\n    padding: 16px;\n    background: var(--white);\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": "tableContainer___f8SGk"
};
export default ___CSS_LOADER_EXPORT___;
